import * as React from "react"
import { App } from "./app"
import { ExtInfoRadioButton } from "./ExtInfoRadioButton"
import { Assert } from "./PADebug"
import { MakeNational } from "./BDKalkCore"
import { ExtDataGW } from "./ExtDataGW"
import { ChoiseControlExtInfoUnit } from "./ChoiseControlExtInfoUnit"
import { PADebug } from "./PADebug"

interface ExtInfoViewVm {
    app: App
}

// ExtInfoViewGW draws extended info to the selected article when it's expanded, otherwise it won't be rendered.
export class ExtInfoViewGW extends React.Component<ExtInfoViewVm, {}> {

    constructor(props: ExtInfoViewVm) {
        super(props);
        this.m_index = 11000
        this.m_choises = new Array<ChoiseControlExtInfoUnit>()
        this.m_clickedLocation = ""
        this.m_clickedChoise = null
        this.m_enteredControlValue = 0
        this.m_enteredControlValueIndex - 1
    }

    // Corrects the ext info window items displayed decimals to using comma ',' and always 2 decimals
    correctDecimals(str: string, addNOK:boolean) {
        var passedComma = false
        var decimalsAdded = 0
        var result = ""

        for (var i = 0; i < str.length; i++) {
            if (str[i] == ".") {
                passedComma = true
                result += ","
            }
            else {
                result += str[i]

                if (passedComma == true) {
                    decimalsAdded++

                    if (decimalsAdded > 1) {
                        break
                    }
                }
            }
        }

        if ((passedComma == true) && (decimalsAdded == 1)){
            result += "0"
        }

        if ((passedComma == true) && (decimalsAdded == 0)) {
            result += "00"
        }

        if(addNOK == true) {
            result += " NOK"
        }

        return MakeNational(result)
    }
    
    OnClickImage() {
    }

    mouseOutImageHandler() {
        var extData = this.props.app.GetCore().GetExtData();
        extData && extData.SetHoveredProductImage(false)
        this.forceUpdate()
    }

    mouseOverImageHandler() {
        var extData = this.props.app.GetCore().GetExtData();
        extData && extData.SetHoveredProductImage(true)
        this.forceUpdate()
    }

    // Rendering the entire Ext info view
    render() {
        // This refreshes the access handle to this ext info view with the latest instance (since redrawn components will replace the previous ones)
        this.props.app.GetCore().UpdateExtInfoViewHandle(this)

        if (this.props.app.state.ExtInfoUp == false) {
            // Ext.info is toggled away and won't be shown
            return <div>
            </div>
        }

        var initEditValue = "initial value - change this!"
        var article = this.props.app.GetSelectedArticle()
        var extData = this.props.app.GetCore().GetExtData()
        
        if (extData == null) {
            this.props.app.GetCore().LoadExtData(null)
            return <div style={{
                backgroundColor: '#EAf3FF',
                fontSize: "10px"
            }}>Henter utvidet vare info..</div>
        }

        if (extData.GetIsDefault() == true) {
            return <div style={{
                height: "40px",
                backgroundColor: '#EAf3FF' }}>
                <div style={{
                    marginLeft: "20px",
                    position: "relative",
                    top: "14px",
                    fontSize: "10px",
                    color:"red"}}>Utvidet vare info finnes ikke for denne varen.</div>
            </div>
        }

        // Left side contents
        var prisBokString = ""
        var distributorString = ""
        var identifierString = ""
        var identifierOldString = ""
        var eanNoString = ""
        var groupString = ""
        var nobbString = ""
        var nobbOwnerString = ""
        var nobbModuleString = ""
        var packageUnitString = ""
        var packageAmountString = ""
        // Right side contents
        var descriptionA = ""
        var descriptionB = ""
        var typeString = ""
        var unitString = ""
        var discountString = ""
        var basePrizeString = 0
        // var purchasePrizeString = 0
        var recPrizeString = 0
        var totalWeighttring = 0
        var supplierString = ""

        var supp = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()]

        if (supp != null) {
            supplierString = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].navn
        }

        if (article != null) {
            // Left side contents
            distributorString = article.GetDistributor()
            identifierString = article.GetSupplyIdentifier()
            identifierOldString = article.GetSupplyIdentifierOld()
            if (identifierOldString != "") {
                identifierOldString = identifierOldString + ")"  // " (Tidligere ID: " + 
            }

            var param: ExtDataGW | null = null

            if (this.props.app.GetCore().HasActiveExtData() == true) {
                if (article.GetSelectionLabel() == this.props.app.GetSelectionID()) {
                    param = this.props.app.GetCore().GetExtData()
                }
            }

            prisBokString = this.props.app.GetCore().GetPriceBookDescription(article.GetPriceBook())
            eanNoString = article.GetEanNo(param)
            groupString = article.GetGroupID()
            nobbString = article.GetNobb()
            nobbOwnerString = article.GetNobbOwner()
            nobbModuleString = article.GetNobbModule()
            typeString = article.GetType()
            // Right side contents

            descriptionA = article.GetDescription()
            descriptionB = article.GetDescription2()
            packageAmountString = article.GetAmountPerPackage().toString()
            packageUnitString = article.GetPackageUnit()
            unitString = article.GetUnit()
            discountString = this.GetValueAsControlString((article.GetDiscountFactor() * 100), 2) + "%" 
            basePrizeString = article.GetBasePrize()
            recPrizeString = article.GetRecommendedPrize()
        }
        else {
            Assert(false, "ExtInfoView - ERROR: no article selected while rending ExtInfoViewGW!")
            return <div></div>
        }
        
        const radioWindowHeight = extData.GetRadioHeight()
        const radioWindowHeightStr = radioWindowHeight.toString() + "px"
        const radioWindowHeightMarginStr = (radioWindowHeight + 10).toString() + "px"

        const titleHeight = 33
        const dataAreaHeight = 162
        const miniImageAreaWidth = 220

        const bottomPaddingHeight = 30
        const leftPaddingImage = 10
        const miniImageAreaWidthStr = (miniImageAreaWidth + leftPaddingImage).toString() + "px"
        const dataAreaHeightStr = (dataAreaHeight + bottomPaddingHeight).toString() + "px"
        const titleHeightStr = titleHeight.toString() + "px"
        const totalViewHeight = dataAreaHeight + titleHeight
        const totalViewHeightStr = (totalViewHeight + 18).toString() + "px"
        const totalHeightStr = ((totalViewHeight + radioWindowHeight) + 2).toString() + "px"

        const rowHeightStr = "23px"

        const leftMarginStr = "14px"

        // Creating and filling up a buffer for the left hand side info
        var bufferLeft = new Array<JSX.Element>()

        // Prisbok:
        bufferLeft.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> Prisbok:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{prisBokString}</h5>
        </div>)

        // Leverandør:
        bufferLeft.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> Leverandør:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{supplierString}</h5>
        </div>)

        // ID:
        bufferLeft.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> ID:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{identifierString}</h5>
        </div>)
        
        // Tidligere ID
        if (identifierOldString != "") {
            bufferLeft.push(<div key={this.GetUnique()} style={{ height: "14px", display: "flex", flexDirection: "row" }}>
                <h5 style={{ marginTop: "5px", marginLeft: "10px", width: "80px", textAlign: "right", position: "relative", top: "-9px" }}> (Tidligere ID: </h5>
                <h5 style={{ marginTop: "5px", marginLeft: "10px", position: "relative", top: "-9px" }}>{identifierOldString}</h5>
            </div>)
        }
        
        // Nobb Nr:
        bufferLeft.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> Nobb Nr:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{nobbString}</h5>
        </div>)

        // Nobb Eier:
        bufferLeft.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> Nobb Eier:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{nobbOwnerString}</h5>
        </div>)

        // Nobb Modul:
        bufferLeft.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> Nobb Modul:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{nobbModuleString}</h5>
        </div>)

        // Creating and filling up a buffer for the right hand side info
        var bufferRight = new Array<JSX.Element>()

        // Varegruppe:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> Varegruppe:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{groupString}</h5>
        </div>)

        // Vareklasse:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "75px", textAlign: "right" }}> Vareklasse:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{typeString}</h5>
        </div>)

        /* Pakke enh:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "75px", textAlign: "right" }}> Pakke enh:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{packageUnitString}</h5>
        </div>)*/

        /* Antall/pakke:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "75px", textAlign: "right" }}> Antall/pakke:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{packageAmountString}</h5>
        </div>)*/

        // Ean Nr:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right" }}> Ean Nr:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{eanNoString}</h5>
        </div>)

        // Rabatt:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "75px", textAlign: "right" }}> Rabatt:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{discountString}</h5>
        </div>)

        // Grunn pris:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "75px", textAlign: "right" }}> Grunn pris:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{this.correctDecimals(basePrizeString.toString(), true)}</h5>
        </div>)

        // Veil. pris:
        bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "75px", textAlign: "right" }}> Veil. pris:</h5>
            <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{this.correctDecimals(recPrizeString.toString(), true)}</h5>
        </div>)

        var totVekt = extData.GetTotalWeight()

        if ((totVekt != null) && (totVekt > 0)) {
            // Total vekt:
            bufferRight.push(<div key={this.GetUnique()} style={{ height: rowHeightStr, display: "flex", flexDirection: "row" }}>
                <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "75px", textAlign: "right" }}> Total vekt:</h5>
                <h5 style={{ marginTop: "5px", marginLeft: "10px" }}>{this.correctDecimals(totVekt.toString(), false) + " kg"}</h5>
            </div>)
        }

        // Let's take for granted that all wares have at least one supplier registered, but if not, then we'll at least know what caused the thread to end.
        // Assert(extData.GetLeverandorer() != null, "in ExtInfoView.render() - an article's ext info did not have any suppliers!")
        Assert(extData.GetLeverandorer().length > 0, "in ExtInfoView.render() - an article's ext info did not have any suppliers!")

        // Adding an article description section here in case a description has been added to the article (otherwise there won't be any such section at all)
        var vareBeskr = <div></div>
        if (extData.GetVarebeskrivelse() != null) {
            if (extData.GetVarebeskrivelse() != "") {
                vareBeskr = <div style={{ width: "100%", backgroundColor: '#EAf3FF', borderTop: "1px solid #B9B9B9" }}>
                    <h4 style={{ marginLeft: "14px", backgroundColor: '#EAf3FF', position: "relative", top: "8px", fontWeight: "bold" }}>Varebeskrivelse:</h4>
                    <div style={{ width: "calc(100% - 28px)", backgroundColor: '#EAf3FF', position: "relative", left: "14px" }}>
                        {extData.GetVarebeskrivelse()}
                    </div>
                    <div style={{ height: "15px", width: "100%", backgroundColor: '#EAf3FF' }}>
                    </div>
                </div>
            }
        }

        // A small product image will be displayed if there is any added for this product, let's first find that out...
        var hasImage = false
        var imgStr = ""
        if (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier != null) {
            for (var im = 0; im < extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier.length; im++) {
                if (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[im].mediaType == "PB") {
                    imgStr = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[im].url
                    hasImage = true
                    break
                }
            }
        }

        // If the selected supplier does not have any product image provided, then we will take a look through the other suppliers
        // for the same product, to see if there's an image that we can use.
        for (var lev = 0; (lev < extData.GetLeverandorer().length) && (hasImage == false); lev++) {
            if (extData.GetLeverandorer()[lev].medier == undefined) {
                continue
            }

            for (var im = 0; im < extData.GetLeverandorer()[lev].medier.length; im++) {
                if (extData.GetLeverandorer()[lev].medier[im].mediaType == "PB") {
                    imgStr = extData.GetLeverandorer()[lev].medier[im].url
                    hasImage = true
                    break
                }
            }
        }

        var minorImage // holder for the image, hovered image or image replacement
        if (hasImage == true) {
            // First we must ensure that the image url is using https instead of http, to make it run smoothly on internet explorer 
            if (imgStr.length > 6) {
                var finalUrl = imgStr

                if ((imgStr.charAt(0) == "h") && (imgStr.charAt(1) == "t") && (imgStr.charAt(2) == "t") && (imgStr.charAt(3) == "p") && (imgStr.charAt(4) != "s")) {
                    finalUrl = "https"

                    for (let i = 4; i < imgStr.length; i++) {
                        finalUrl += imgStr.charAt(i)
                    }

                    imgStr = finalUrl
                }
            }

            // Before using this image, its url should lead to the medium rather than the xLarge sized image as in the data source, so let's manipulate the url..
            var medStr = ""
            for (var h = 0; h < imgStr.length - 6; h++) {
                medStr += imgStr.charAt(h)
            }

            medStr = medStr + "medium"

            // Making an assertion in case backend have been changed from how it presently distribute product image data
            Assert((imgStr.charAt(h) == "x"), "ExtInfoView.render - input data string for the image was supposed to end with xlarge but did not, has the data source been changed?")

            var borderStr = "1px solid #EAf3FF"

            if (extData.GetHoveredProductImage() == true) {
                borderStr = "1px solid #225599"
            }

            minorImage = <div style={{ display: "flex", flexDirection: "row", width: ((miniImageAreaWidth + leftPaddingImage).toString() + "px") }}> 

                <div style={{ width: (leftPaddingImage.toString() + "px")}}>
                    {/*  image area left margin   */}
                </div>

                <div style={{ display: "flex", flexDirection: "column", width: (miniImageAreaWidth.toString() + "px"), height: "100%" }}>
                {/*  Product Image Title   */}
                    <div style={{ width: "100%", height: "38px" }}>
                        <h4 style={{ marginTop: "8px", fontWeight:"bold" }}>Produktbilde:</h4>
                    </div>
                {/*  Product Image (is a clickable link) */}
                <a href={imgStr} target="_blank">
                    <img
                        src={medStr}
                        alt={"Henter bilde.."}
                        onClick={this.OnClickImage.bind(this)}
                        onMouseOut={this.mouseOutImageHandler.bind(this)}
                        onMouseOver={e => this.mouseOverImageHandler()}
                        style={{ cursor: "pointer", position: "relative", top: "-4px", border: borderStr, backgroundColor: "white", maxHeight: "151px", maxWidth: "204px" }} />
                </a>
                <div style={{ width: "100%", height: "30px" }}>
                    {/* bottom margin */}
                </div>
                </div>
            </div>
        }
        else {
            minorImage = <div style={{height:"7px"}}></div> // Margin above eventual product links if they appear on top as no image takes up the place above
        }

        var linksCollection = new Array<JSX.Element>()

        // Here the links are added, first into a collection (so that leaving their area with the mouse can be handled)
        linksCollection.push(
            <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                <h4 style={{ marginTop: "5px", marginLeft: "14px", fontWeight: "bold", width: "100%", textAlign: "left" }}>Informasjonslenker:</h4>
            </div>)

        if (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier != undefined) {
            for (var b = 0; b < extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier.length; b++) {
                const index = b
                const link = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[b].url

                const hoverColor = (extData.GetHoveredMediaLink() == index) ? "#7777FF" : "#2255AA"
                linksCollection.push(<a key={this.GetUnique()} href={extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[b].url} target="_blank" style={{ height: "20px", width: "100%", fontVariant: "underlined" }}>
                    <div onMouseEnter={e => this.OnMouseEnterMediaLink(index)} style={{ height: "20px", width: "calc(100% -" + leftMarginStr + ")", marginLeft: leftMarginStr, color: hoverColor, cursor: "pointer", fontVariant: "underlined" }}>
                        {this.DescribeMediaType(extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[b].mediaType) + this.GetNumericExtension(index)}
                    </div>
                </a>)
            }
        }
        
        // Throwing in a bottom margin at the end
        linksCollection.push(<div key={this.GetUnique()} style={{ height: "20px" }}></div>)

        var linksPart = <div onMouseLeave={this.OnLeaveLinks.bind(this)}>
            {linksCollection}
        </div>

        if (linksCollection.length == 2) {
            linksPart = <div></div>
        }

        var rightInteraction = <div>
            {minorImage}
            <div onMouseLeave={this.OnLeaveLinks.bind(this)}>
                {linksPart}
            </div>
        </div>
        
        var midsetionWidth = "calc(100% - " + ((miniImageAreaWidth + 35).toString()) + "px)"

        var pakkeArray = new Array<JSX.Element>()
        const defaultPakke = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetValgtPakkeIndex()].pakningsEnhet.id
        const defaultPakkeType = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetValgtPakkeIndex()].pakningsEnhet.beskrivelse
        var unitsTitle = "Alternative enheter - omregnes til " + defaultPakkeType + " (" + defaultPakke + ")"

        // Adds numeric controls for alternate package types, while the default package unit is already representated at the selected article item's numeric control, so it's ignored here..
        for (var i = 0; i < extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger.length; i++) {
            if (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[i].pakningsEnhet.id != defaultPakke) {
                const index = i
                const unitId = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[i].pakningsEnhet.id
                const unitType = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[i].pakningsEnhet.beskrivelse
                const unitMeasure = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[i].kalkulertInnhold
                const unitProps = 
                    pakkeArray.push(<div key={this.GetUnique()} style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                    <ChoiseControlExtInfoUnit core={this.props.app.GetCore()} extInfoView={this} index={index} unitMeasure={unitMeasure} />
                    <div style={{ width: "20px" }}></div>
                    <div style={{ marginTop: "5px" }}>{unitType + " " + this.GetUnitFactorString(unitMeasure)}</div>
                </div>)

                pakkeArray.push(<div key={this.GetUnique()} style={{ height: "5px" }}> {/* margin between alternate package units */}
                </div>)
            }
        }

        var altUnits = <div>
            <div style={{ height: "9px" }}> {/* top margin of alternate units section */}
            </div>
            <div style={{ fontWeight: "bold" }} >{unitsTitle}
            </div>
            <div style={{ height: "18px" }}> {/* margin before the first alternate package unit  */}
            </div>
            {pakkeArray}
        </div>

        if (pakkeArray.length == 0) {
            altUnits = <div></div>
        }
        
        var interaksjonsdel = <div onClick={e => this.OnClick() } style={{ width: "100%", backgroundColor: "#EAf3FF", display: "flex", flexDirection: "row" }}>
            <div style={{width:"14px"}}> {/* margin left */}
            </div>

            <div onClick={e => this.OnClick()} style={{ width: "calc(100% - 28px)", backgroundColor: "#EAf3FF", display: "flex", flexDirection: "row", flexWrap:"wrap" }}>
                <div style={{ padding: "20px"}}>
                    {altUnits}
                </div>

                <div style={{ padding: "20px"}}>
                    {this.DrawPakningsMal()}
                </div>

                <div style={{ padding: "20px"}}>
                    {linksPart}
                </div>

                <div style={{ padding: "20px"}}>
                    {minorImage}
                </div>
            </div>
        </div>
        
        var vareinfo = <div style={{ width: "100%", backgroundColor: '#EAf3FF', borderTop: "1px solid #B9B9B9" }}>
            <div className="pageSection sectionTitle" style={{ display: "flex", flexDirection: "row", height: titleHeightStr, width: "100%" }}>
                {/*  extInfo Title   */}
                <div style={{ width: "calc(100% - " + miniImageAreaWidth + ")" }}>
                    <h4 style={{ marginLeft: "14px", marginTop: "8px", fontWeight: "bold" }}>Utvidet vareinformasjon:</h4>
                </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", height: dataAreaHeightStr, width: "100%", backgroundColor: '#EAf3FF' }}>
                <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", backgroundColor: '#EAf3FF' }}>
                    <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                        <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "50%", backgroundColor: '#EAf3FF' }}>
                            {/*  extInfo Left side   */}
                            <div style={{ display: "flex", flexDirection: "column", height: "calc(100% - 18px)", width: "100%", position: "relative", top: "2px" }}>
                                {bufferLeft}
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "50%", backgroundColor: '#EAf3FF' }}>
                            {/*  extInfo Right side   */}
                            <div style={{ display: "flex", flexDirection: "column", height: "calc(100% - 18px)", width: "100%", position: "relative", top: "2px" }}>
                                {bufferRight}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        var finalView = <div onClick={e => this.OnClick()} style={{ width: "100%", backgroundColor: "#EAf3FF" }}>
            {interaksjonsdel}
            {vareBeskr}
            {vareinfo}
        </div>

        var separator = <div style={{ height: "30px", width: "100%", backgroundColor: "black", color: "white" }}>
            (Separator - ny og tidligere version av utvidet vare info) 
        </div>

        var oldExtInfoView = <div></div>

        if ((this.props.app.GetCore().GetShouldDisplayOldExtInfoView() == true) || ((PADebug.IsDebuging() == true) && (this.props.app.state.DisplayMode == this.props.app.DMode.Favorites))) {
            /* (this add is switched off by default, and only used within development) */
            oldExtInfoView = <div>
                {separator}
                <div style={{ display: "flex", flexDirection: "row", height: totalViewHeightStr, width: "100%", backgroundColor: '#EAf3FF' }}>
                    <div style={{ height: totalViewHeightStr, width: "calc(100% - " + miniImageAreaWidthStr + ")" }}>
                        <div className="pageSection sectionTitle" style={{ display: "flex", flexDirection: "row", height: titleHeightStr, width: "100%" }}>
                            {/*  extInfo Title   */}
                            <div style={{ width: "calc(100% - " + miniImageAreaWidth + ")" }}>
                                <h4 style={{ marginLeft: "14px", marginTop: "8px", fontWeight: "bold" }}>Utvidet vareinformasjon:</h4>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", height: dataAreaHeightStr, width: "100%", backgroundColor: '#EAf3FF' }}>
                            <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", backgroundColor: '#EAf3FF' }}>
                                <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                                    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "50%", backgroundColor: '#EAf3FF' }}>
                                        {/*  extInfo Left side   */}
                                        <div style={{ display: "flex", flexDirection: "column", height: "calc(100% - 18px)", width: "100%", position: "relative", top: "2px" }}>
                                            {bufferLeft}
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "50%", backgroundColor: '#EAf3FF' }}>
                                        {/*  extInfo Right side   */}
                                        <div style={{ display: "flex", flexDirection: "column", height: "calc(100% - 18px)", width: "100%", position: "relative", top: "2px" }}>
                                            {bufferRight}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", width: miniImageAreaWidth, height: "100%" }}>
                        {/*  Product Image & Title   */}
                        {minorImage}
                    </div>
                </div>
                {vareBeskr}
                <div style={{ height: radioWindowHeightStr, width: "100%", backgroundColor: '#EAf3FF' }}>
                    <ExtInfoRadioButton app={this.props.app} article={article} extData={extData} options={["test"]} extInfoView={this} radioHeight={radioWindowHeight} />
                </div>
            </div>
        }

        return <div>
            {finalView}
            {oldExtInfoView /* (this add is switched off by default, and only used within development) */}
        </div>
    }

    OnClick() {
        if (this.m_clickedLocation == "input") {

            if (this.m_clickedChoise == null) {
                return
            }
            
            this.props.app.GetCore().SetInputItemExtInfoUnit(this.m_clickedChoise.props.index)
        }
        
        if ((this.m_clickedLocation == "plus") && (this.m_clickedChoise != null)) {
            
            var altVal = this.GetAlternateValue(this.m_clickedChoise)

            if (altVal == undefined) {
                Assert(false, "ExtInfoView.onclick - GetAlternateValue for a control returned undefined!")
                return
            }

            if (altVal % 1 != 0) {
                altVal -= (altVal % 1)
                altVal++
            }
            else {
                altVal++
            }

            this.InsertControlValue(altVal, this.m_clickedChoise)
            this.props.app.GetCore().ClearInput(0)
            this.props.app.GetCore().RedrawTotalSum()
        }

        if ((this.m_clickedLocation == "minus") && (this.m_clickedChoise != null)) {

            var altVal = this.GetAlternateValue(this.m_clickedChoise)

            if (altVal == undefined) {
                Assert(false, "ExtInfoView.onclick - GetAlternateValue for a control returned undefined!")
                return
            }

            if (altVal % 1 != 0) {
                altVal -= (altVal % 1)
            }
            else {
                altVal--

                if (altVal < 0) {
                    altVal = 0
                }
            }

            this.InsertControlValue(altVal, this.m_clickedChoise)
            this.props.app.GetCore().ClearInput(0)
            this.props.app.GetCore().RedrawTotalSum()
        }

        this.m_clickedLocation = ""
        this.m_clickedChoise = null
    }

    ConnectUnitChoise(choise: ChoiseControlExtInfoUnit) {
        this.m_choises.push(choise)
    }

    SetLocation(location: string, control: ChoiseControlExtInfoUnit) {
        this.m_clickedLocation = location
        this.m_clickedChoise = control
    }

    // Clears the trace of the latest control's given amount, meaning the values are once again based on the article's amount
    ResetControlInsertion() {
        this.m_enteredControlValue = 0
        this.m_enteredControlValueIndex = -1
        this.forceUpdate()
    }

    InsertControlValue(value: number, control: ChoiseControlExtInfoUnit) {
        this.m_enteredControlValue = value
        this.m_enteredControlValueIndex = control.props.index

        const article = this.props.app.GetSelectedArticle()

        if (article == null) {
            Assert(false, "ExtInfoView.InsertControlValue - Selected article was null!")
            return
        }

        const extInfo = this.props.app.GetCore().GetExtData()

        if (extInfo == null) {
            Assert(false, "ExtInfoView.InsertControlValue - ExtInfo was null!")
            return
        }

        var wasNotInserted = ((article.GetIfHasExtData() == null) && (article.GetAmount() == 0) && this.props.app.state.DisplayMode != this.props.app.DMode.QReport)

        const basicMeasure = extInfo.GetLeverandorer()[extInfo.GetValgtLeverantorIndex()].pakninger[extInfo.GetValgtPakkeIndex()].kalkulertInnhold
        const unitMeasure = control.props.unitMeasure
        var amount = (value * unitMeasure) / basicMeasure
        
        article.SetAmount(amount)

        if ((amount > 0) && (wasNotInserted == true)) {
            this.props.app.GetCore().InsertSelectArticle(article)
        }

        this.props.app.GetCore().UpdateSelectedItem()
        this.forceUpdate()
    }

    GetAlternateValue(control: ChoiseControlExtInfoUnit) {
        const article = this.props.app.GetSelectedArticle()

        if (article == null) {
            Assert(false, "ExtInfoView.GetAlternateValue - Selected article was null!")
            return
        }

        const extInfo = this.props.app.GetCore().GetExtData()

        if (extInfo == null) {
            Assert(false, "ExtInfoView.GetAlternateValue - ExtInfo was null!")
            return
        }

        if (this.m_enteredControlValueIndex != -1) {

            if (this.m_enteredControlValueIndex == control.props.index) {
                /* We are getting the value of the control from where the last value was entered, 
                   so instead of calculating its current value from the articles amount, we reuse
                   the latest entered value as is
                */
                return this.m_enteredControlValue
            }
            else {
                /* There is a different control into which a value was entered, we will use its
                   entered amount and base this control's value by a comparision between the units greatness
                */
                
                for (var i = 0; i < this.m_choises.length; i++) {
                    if (this.m_choises[i].props.index == this.m_enteredControlValueIndex) {
                        var originalAmount = this.m_enteredControlValue * this.m_choises[i].props.unitMeasure

                        return originalAmount / control.props.unitMeasure
                    }
                }
            }
        }

        // No amounts have been entered into any alternate unit controls lately, so the value will be calculated from the original article's amount
        const basicMeasure = extInfo.GetLeverandorer()[extInfo.GetValgtLeverantorIndex()].pakninger[extInfo.GetValgtPakkeIndex()].kalkulertInnhold
        const unitMeasure = control.props.unitMeasure
        const amount = article.GetAmount()

        var result = (amount * basicMeasure) / unitMeasure

        return result
    }

    GetUnitFactorString(unitMeasure: number) {
        const article = this.props.app.GetSelectedArticle()

        if (article == null) {
            Assert(false, "ExtInfoView.GetAlternateValue - Selected article was null!")
            return ""
        }

        const extInfo = this.props.app.GetCore().GetExtData()

        if (extInfo == null) {
            Assert(false, "ExtInfoView.GetAlternateValue - ExtInfo was null!")
            return ""
        }

        const basicMeasure = extInfo.GetLeverandorer()[extInfo.GetValgtLeverantorIndex()].pakninger[extInfo.GetValgtPakkeIndex()].kalkulertInnhold

        const basicId = extInfo.GetLeverandorer()[extInfo.GetValgtLeverantorIndex()].pakninger[extInfo.GetValgtPakkeIndex()].pakningsEnhet.id

        var result = unitMeasure / basicMeasure

        return "(" + this.GetValueAsControlString(result, null) + " " + basicId + ")"
    }

    /* If more than one product info link have the same type, an " #1", " #2" and so on will be added in the end of that description, to give
     * it some sense of identity and so that the user may keep track of which one was last he/she clicked upon.   */
    GetNumericExtension(index: number) {
        const extData = this.props.app.GetCore().GetExtData()
        const type = extData && extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[index].mediaType
        var thisInOrder = 0
        var totalSimilar = 0

        for (var i = 0; extData && i < extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier.length; i++) {
            const current = i
            if (type == extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[current].mediaType) {
                if (current == index) {
                    thisInOrder = totalSimilar + 1
                }

                totalSimilar++
            }
        }

        if (totalSimilar > 1) {
            return " #" + thisInOrder.toString()
        }
        else {
            return ""
        }
    }
    
    DrawPakningsMal() {
        var bufferDim = new Array<JSX.Element>()
        var article = this.props.app.GetSelectedArticle()
        
        var extData = this.props.app.GetCore().GetExtData()
        
        if (extData == null) {
            this.props.app.GetCore().LoadExtData(null)
            return <div></div>
        }

        if (!article) {
            Assert(false, "ExtInfoView.DrawPakningsMal() - no article was selected!")
            return <div>
            </div>
        }

        Assert(article.GetSelectionLabel() == extData.GetSelectionLabel(), "ExtInfoView.DrawPakningsMal() - there's an article and extData missmatch!")

        var specificUnitStr = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id

        var mal = extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsMal
        // Preparing the radio options for dimensions (pakningsMal)
        if (mal != null) { // Checking first the dims arent null, to avoid crashes if it would be.
            const visibleCircleDim = (mal.length > 1) ? "visible" : "hidden"
            
            // Choise of option for the dimensions of the package
            if (mal.length > 0) {
                bufferDim.push(
                    <h4 key={this.GetUnique()} style={{ position: "relative", top: "5px", fontWeight: "bold", cursor: "pointer" }}>{"Pakningsmål - " + specificUnitStr + ":"}</h4>
                )
            }
            else {
                return <div></div>
            }

            // Bredde:
            if (mal[extData.GetValgtDimIndex()].bredde != null) {
                const breddeStr = MakeNational(mal[extData.GetValgtDimIndex()].bredde.toString())
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Bredde:</h5>
                        <h5 style={{ marginLeft: "10px", textAlign: "left", color: "#333844" }}>{breddeStr}</h5>
                    </div>)
            }

            // Hoyde:
            if (mal[extData.GetValgtDimIndex()].hoyde != null) {
                const hoydeStr = MakeNational(mal[extData.GetValgtDimIndex()].hoyde.toString())
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Høyde:</h5>
                        <h5 style={{ marginLeft: "10px", textAlign: "left", color: "#333844" }}>{hoydeStr}</h5>
                    </div>)
            }

            // Lengde:
            if (mal[extData.GetValgtDimIndex()].lengde != null) {
                const lengdeStr = MakeNational(mal[extData.GetValgtDimIndex()].lengde.toString())
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Lengde:</h5>
                        <h5 style={{ marginLeft: "10px", textAlign: "left", color: "#333844" }}>{lengdeStr}</h5>
                    </div>)
            }

            // Type:
            if (mal[extData.GetValgtDimIndex()].type != null) {
                const typeStr = MakeNational(mal[extData.GetValgtDimIndex()].type.toString())
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Type:</h5>
                        <h5 style={{ marginLeft: "10px", textAlign: "left", color: "#333844" }}>{typeStr}</h5>
                    </div>)
            }

            // Vekt:
            if (mal[extData.GetValgtDimIndex()].vekt != null) {
                const vektStr = MakeNational(mal[extData.GetValgtDimIndex()].vekt.toString())
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Vekt:</h5>
                        <h5 style={{ marginLeft: "10px", textAlign: "left", color: "#333844" }}>{vektStr}</h5>
                    </div>)
            }

            // Volum:
            if (mal[extData.GetValgtDimIndex()].volum != null) {
                const volumStr = MakeNational(mal[extData.GetValgtDimIndex()].volum.toString())
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Volum:</h5>
                        <h5 style={{ marginLeft: "10px", textAlign: "left", color: "#333844" }}>{volumStr}</h5>
                    </div>)
            }
            
            // In storage, available for ordering
            const inStorStr = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].lagerfort == true) ? "Ja" : "Nei"
            const inStorColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].lagerfort == true) ? "#229922" : "#992222"
            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Lagerført:</h5>
                    <h5 style={{ marginLeft: "10px", fontWeight: "bold", textAlign: "left", color: inStorColor }}>{inStorStr}</h5>
                </div>)

            const orderableStr = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].bestillbar == true) ? "Ja" : "Nei"
            const orderableColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].bestillbar == true) ? "#229922" : "#992222"
            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Bestillbar:</h5>
                    <h5 style={{ marginLeft: "10px", fontWeight: "bold", textAlign: "left", color: orderableColor }}>{orderableStr}</h5>
                </div>)

            // const isFPAK = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit()) ? "Ja" : "Nei"
            // const fpakColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit()) ? "#229922" : "#992222"
            const isFPAK = extData.GetFpakUnitDescription(article)
            const fpakColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit(article)) ? "#229922" : "#444444"
            const fpakWeight = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit(article)) ? "bold" : "normal"

            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>FPAK:</h5>
                    <h5 style={{ fontWeight: fpakWeight, marginLeft: "10px", textAlign: "left", color: fpakColor }}>{isFPAK}</h5>
                </div>)
        }
        else {
            bufferDim.push(
                <h4 key={this.GetUnique()} style={{ position: "relative", top: "5px", fontWeight: "bold", cursor: "pointer" }}>{"Pakningsmål - " + specificUnitStr + ":"}</h4>
            )

            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Dimensjoner:</h5>
                    <h5 style={{ marginLeft: "10px", textAlign: "left", color: "#333844" }}>(Info savnes)</h5>
                </div>)
            
            // In storage, available for ordering
            const inStorStr = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].lagerfort == true) ? "Ja" : "Nei"
            const inStorColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].lagerfort == true) ? "#229922" : "#992222"
            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Lagerført:</h5>
                    <h5 style={{ marginLeft: "10px", fontWeight: "bold", textAlign: "left", color: inStorColor }}>{inStorStr}</h5>
                </div>)

            const orderableStr = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].bestillbar == true) ? "Ja" : "Nei"
            const orderableColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].bestillbar == true) ? "#229922" : "#992222"
            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Bestillbar:</h5>
                    <h5 style={{ marginLeft: "10px", fontWeight: "bold", textAlign: "left", color: orderableColor }}>{orderableStr}</h5>
                </div>)

            // const isFPAK = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit()) ? "Ja" : "Nei"
            // const fpakColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit()) ? "#229922" : "#992222"
            const isFPAK = extData.GetFpakUnitDescription(article)
            const fpakColor = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit(article)) ? "#229922" : "#444444"
            const fpakWeight = (extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].pakninger[extData.GetActivePakkeIndex()].pakningsEnhet.id == extData.GetFpakUnit(article)) ? "bold" : "normal"

            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>FPAK:</h5>
                    <h5 style={{ fontWeight: fpakWeight, marginLeft: "10px", textAlign: "left", color: fpakColor }}>{isFPAK}</h5>
                </div>)
        }

        // Margin at bottom
        bufferDim.push(
            <div key={this.GetUnique()} style={{ height: "12px" }}></div>
        )

        return <div>
            {bufferDim}
        </div>
    }

    // DescribeMediaType tries to recognize what the short version of a media description stands for and if so returns a more descriptive string instead of these few given letters
    DescribeMediaType(desc: string) {
        if (desc == "PRE") {
            return "Produktdatablad"
        }

        if (desc == "MAN") {
            return "Monteringsanvisning"
        }

        if (desc == "HMF") {
            return "Helse, miljø og sikkerhet faktablad"
        }

        if (desc == "HMS") {
            return "Sikkerhetsdatablad"
        }

        if (desc == "SER") {
            return "Sertifikat"
        }

        if (desc == "FDV") {
            return "Forvaltning, drift og vedlikehold"
        }

        if (desc == "BRO") {
            return "Brosjyre"
        }

        if (desc == "MLJ") {
            return "Miljødeklarasjon"
        }

        if (desc == "IFC") {
            return "Industry foundation classes"
        }

        if (desc == "EPD") {
            return "Miljødeklarasjon"
        }

        if (desc == "YTE") {
            return "Ytelseserklæring"
        }

        if (desc == "BREEAM") {
            return "Egenerklæring"
        }

        if (desc == "MTG") {
            return "Målsatt tegning"
        }

        if (desc == "ESDS") {
            return "Eksponeringssikkerhetsdatablad"
        }

        if (desc == "VB") {
            return "Verneblad"
        }

        if (desc == "PB") {
            return "Produktbilde"
        }

        if (desc == "MB") {
            return "Miljøbilde"
        }

        if ((desc == "") || (desc == null)) {
            return "uspesifisert lenke"
        }

        /*  As default, the unchanged description string is returned as it is. The above descriptions are taken from this documentation page:
         *  http://dok.byggtjeneste.no/importeksport/#VareEksport%208.0_xsd~c-MedierType.html  ..which won't cover all possible media types today,
         *  so if you find more descriptions for other types not enlisted above, please add them as well here above  ^                     */
        return desc
    }

    // Hovering over media links will shine them up
    OnMouseEnterMediaLink(index: number) {
        var extData = this.props.app.GetCore().GetExtData();
        extData && extData.SetHoveredMediaLink(index)
        this.forceUpdate()
    }

    OnLeaveLinks() {
        var extData = this.props.app.GetCore().GetExtData();
        extData && extData.SetHoveredMediaLink(-1)
        this.forceUpdate()
    }

    GetValueAsControlString(value: number, maxDecimals: number | null) {
        var decimalsToShow = 4

        if (value >= 10) {
            decimalsToShow = 3
        }

        if (value >= 100) {
            decimalsToShow = 2
        }

        if (value >= 1000) {
            decimalsToShow = 1
        }
        
        if (value >= 10000) {
            decimalsToShow = 0
        }

        if (value % 1 == 0) {
            decimalsToShow = 0
        }

        if (maxDecimals != null) {
            if (decimalsToShow > maxDecimals) {
                decimalsToShow = maxDecimals
            } 
        }

        var s = value.toString()
        var passedComma = false
        var decimalsEntered = 0
        var result = ""

        for (var i = 0; i < s.length; i++) {
            if (passedComma == true) {
                if (decimalsToShow > decimalsEntered) {
                    decimalsEntered++
                    if (decimalsToShow == decimalsEntered) {
                        // rounding up/down the value to current 10-potence
                        if (s.length > (i + 1)) {
                            const next = s.charAt(i + 1)

                            if ((next == "5") || (next == "6") || (next == "7") || (next == "8") || (next == "9")) {
                                if (s.charAt(i) == "0") {
                                    result += "1"
                                }

                                if (s.charAt(i) == "1") {
                                    result += "2"
                                }

                                if (s.charAt(i) == "2") {
                                    result += "3"
                                }

                                if (s.charAt(i) == "3") {
                                    result += "4"
                                }

                                if (s.charAt(i) == "4") {
                                    result += "5"
                                }

                                if (s.charAt(i) == "5") {
                                    result += "6"
                                }

                                if (s.charAt(i) == "6") {
                                    result += "7"
                                }

                                if (s.charAt(i) == "7") {
                                    result += "8"
                                }

                                if (s.charAt(i) == "8") {
                                    result += "9"
                                }

                                if (s.charAt(i) == "9") {
                                    result += "9"
                                }
                            }
                            else {
                                result += s.charAt(i)
                            }
                        }
                        else {
                            result += s.charAt(i)
                        }
                    }
                    else {
                        result += s.charAt(i)
                    }
                }
                else {
                    return result
                }
            }
            else {
                if ((s.charAt(i) == ",") || (s.charAt(i) == ".")) {
                    if (decimalsToShow == 0) {
                        return result
                    }
                }

                result += s.charAt(i)
            }

            if ((s.charAt(i) == ",") || (s.charAt(i) == ".")) {
                passedComma = true
            }
        }

        return MakeNational(result)
    }

    private m_clickedLocation : string
    private m_index: number
    private m_choises: Array<ChoiseControlExtInfoUnit>
    private m_clickedChoise: ChoiseControlExtInfoUnit | null
    private m_enteredControlValue: number
    private m_enteredControlValueIndex: number

    GetUnique() {
        const previous = this.m_index
        this.m_index++
        return previous
    }

    GetInputActive(input: ChoiseControlExtInfoUnit) {

        if (input.props.index == this.props.app.GetCore().GetInputUnitExtInfo()) {
            return true
        }

        return false
    }
}



// WEBPACK FOOTER //
// ./client/view/ExtInfoViewGW.tsx